import React from 'react';
import { Box } from '@mui/material';

type AspectRatio = '4x3' | '1x1' | '9x16';

type DevicePreviewFrameProps = {
  aspectRatio: AspectRatio;
  children: React.ReactNode;
  backgroundImage: string;
};

const frameStyles: Record<AspectRatio, React.CSSProperties> = {
  '4x3': {
    width: '402.96px',
    height: '290.91px',
    borderRadius: '18px',
    overflow: 'hidden',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '1x1': {
    width: '402.96px',
    height: '290.91px',
    borderRadius: '18px',
    overflow: 'hidden',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '9x16': {
    position: 'relative',
    width: '176.91px',
    height: '294px',
    borderRadius: '16px',
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
  },
};

export const DevicePreviewFrame = ({
  aspectRatio,
  children,
  backgroundImage,
}: DevicePreviewFrameProps) => {
  const frameStyle = frameStyles[aspectRatio];

  return <Box sx={{ ...frameStyle, backgroundImage: `url(${backgroundImage})` }}>{children}</Box>;
};
